import {Component, OnInit} from '@angular/core';
import {TokenService} from '../../../../core/auth';
import {BreadcrumbService} from '../../../../breadcrumb.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.page.html',
  styleUrls: ['./dashboard.page.css']
})
export class DashboardPage implements OnInit {
  authUser = this.token.whoAmI();

  constructor(
    private token: TokenService,
    private breadcrumbService: BreadcrumbService
  ) {
    this.breadcrumbService.setItems([
      {label: 'dashboard'},
    ]);
  }

  ngOnInit() {
  }

  getDate() {
    return new Date().getTime();
  }

  hasRole(role: string) {
    return this.authUser.hasRole(role);
  }

  isExpired() {
    return this.authUser.isTokenExpired;
  }
}
